<template>
  <div class="row">
    <div :class="[next ? 'col-lg-4' : 'col-lg-2']">
      <div
        class="row"
        style="display: flex"
      >
        <div :class="[next ? 'col-xs-5' : 'col-xs-12']">
          <div
            class="discount current"
            v-text="getDiscountText(current)"
          />
        </div>
        <template v-if="next">
          <div class="col-xs-2 discount-arrow" />
          <div class="col-xs-5">
            <div
              class="discount next shadow-hover"
              title="Доступна на статусе Platinum"
              v-text="getDiscountText(next)"
            />
          </div>
        </template>
      </div>
    </div>
    <div
      class="discount-description"
      :class="[next ? 'col-lg-8': 'col-lg-10']"
    >
      <p
        class="title"
        v-text="title"
      />
      <p v-text="description" />
    </div>
  </div>
</template>

<script>
import slots from '../../../mixins/slots'

/**
 * Блок со скидками при изменении статуса.
 */
export default {
  name: 'Discount',
  mixins: [slots],
  props: {
    /**
     * Текущая скидка.
     */
    current: {
      type: Number,
      required: true
    },
    /**
     * Новая скидка.
     */
    next: {
      type: Number,
      required: true
    },
    /**
     * Наименование.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Описание.
     */
    description: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * Возвращает текст процента скидки.
     *
     * @param discount
     * @returns {string}
     */
    getDiscountText (discount) {
      return `${discount}%`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.discount {
  max-width: 140px;
  margin: 15px auto;
  background-color: white;
  border-radius: $borderRadiusLarge;
  text-align: center;
  padding: 10px;
  font-size: 3.5em;
}

.discount.current {
  border: 2px solid $textSuccessColor;
  cursor: default;
}

.discount.next:hover {
  cursor: pointer;
}

.discount-arrow {
  text-align: center;
  background-image: url("../../../../../resources/img/arrow-right-geen.png");
  background-repeat: no-repeat;
  background-position: center;
}

.discount-description {
  margin-top: 15px;
}

.discount-description .title {
  font-size: 1.3em;
  font-weight: bold;
}
</style>
